import axios from "axios"
import {Notification} from 'element-ui';

// axios.defaults.baseURL = "http://127.0.0.1:9096/uccn";
// axios.defaults.baseURL = "http://10.0.7.51:8030/uccn";
axios.defaults.baseURL = "/uccn";
axios.defaults.timeout = 1000 * 60;//设置请求超时
axios.interceptors.request.use(
    request => {
        request.headers.common["languageType"] = sessionStorage.getItem("language")==="en" ? "1" : '0';
        return request;
    },
    error => {
        return Promise.reject(error)
    }
);

axios.interceptors.response.use(
    response => {
        if (!response.data.status && response.data.msg) {
            Notification.error({
                title: '错误',
                message: response.data.msg,
            });
        }
        return response.data
    },
    error => {
        return Promise.reject(error)
    }
);

export default axios
